import React from 'react';
import { FaArrowRight } from 'react-icons/fa';
import { Box, Flex, LinkBox, LinkOverlay } from '@chakra-ui/react';

export interface PartnerProps {
  name: string;
  url: string;
  image: React.ReactNode;
}

const PartnerCard = ({ name, image, url }: PartnerProps) => (
  <LinkBox
    h="114px"
    borderRadius="10"
    transition="all 200ms ease-in-out 0ms"
    _hover={{
      boxShadow: '0px 44px 66px 2px rgba(118, 118, 118, .5)',
      borderTopWidth: '3px',
      borderTopStyle: 'solid',
      borderTopColor: 'blue.600',
    }}
  >
    <LinkOverlay href={url} target="_blank">
      <Box h="114px" px={5} borderRadius="10">
        <Flex pt={9} justify="space-between" align="center">
          <Box maxW={28} name={name}>
            {image}
          </Box>
          <FaArrowRight color="secondary700" fontSize="24px" />
        </Flex>
      </Box>
    </LinkOverlay>
  </LinkBox>
);

export default PartnerCard;
